// @ts-check
/**
 * Defines the query keys for listing templates.
 */
export const templateListKeys = {
  /**
   * Represents all template list query keys.
   *
   * @type {['templatesList']}
   */
  all: ['templatesList'],

  /**
   * Generates the envelope query keys for retrieving envelope details.
   *
   * @param {string} search - The fingerprint of the envelope.
   *
   * @returns {['templatesList', string]}
   */
  search: search => [...templateListKeys.all, search],
};

/** @typedef {typeof templateListKeys.all} TAllTemplatesKey */
/** @typedef {ReturnType<typeof templateListKeys.search>} TSearchTemplatesKey */
